interface LiveProps {
    live?: boolean;
}

export default function LiveIcon({ live=true }: LiveProps) {
    return (
        <>
            <div className="relative flex items-center">
                {live &&
                    <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full opacity-75 bg-red-500"></span>
                }
                <span className={`transition relative inline-flex h-3 w-3 rounded-full ${live ? 'bg-red-500' : 'bg-default-500'}`}></span>
            </div>
        </>
    );
}
